import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { map } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SurveyService {
  private readonly apiUrl = environment.apiServer;

  constructor(private readonly http: HttpClient) {}

  updateCancelInvestmentSurvey(
    dateTime: string,
    userEmail: string,
    campaignName: string,
    campaignUrl: string,
    reason: string,
    otherReason?: string,
  ) {
    return this.http
      .put(
        `${this.apiUrl}api/integration/sheet/${environment.surveyFormId.investmentCancellation}`,
        {
          data: [[userEmail, campaignName, campaignUrl, reason, otherReason, dateTime]],
        },
      )
      .pipe(
        map((data: any) => {
          return data;
        }),
      );
  }

  updateRefundInvestmentSurvey(
    dateTime: string,
    userEmail: string,
    campaignName: string,
    campaignUrl: string,
    reason: string,
    otherReason?: string,
  ) {
    return this.http
      .put(`${this.apiUrl}api/integration/sheet/${environment.surveyFormId.refundRequest}`, {
        data: [[userEmail, campaignName, campaignUrl, reason, otherReason, dateTime]],
      })
      .pipe(
        map((data: any) => {
          return data;
        }),
      );
  }
}
